var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, styled, Typography } from '@mui/material';
import React from 'react';
import { gray40opacity10, gray40opacity20, gray75, white } from '../../colors/gray';
import { neutral60opacity05, neutral60opacity20 } from '../../colors/neutral';
import { isLightTheme } from '../../utils/utils';
export var SectionType;
(function (SectionType) {
    SectionType[SectionType["HEADER"] = 0] = "HEADER";
    SectionType[SectionType["TITLE"] = 1] = "TITLE";
})(SectionType || (SectionType = {}));
var Root = styled(Box)(function (_a) {
    var variant = _a.variant, theme = _a.theme;
    var lightTheme = isLightTheme(theme);
    return __assign({ display: 'flex', flexDirection: 'column' }, (variant === 'framed' && {
        backgroundColor: lightTheme ? white : gray75,
        borderColor: lightTheme ? neutral60opacity20 : gray40opacity20,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 3,
    }));
});
var Label = styled(Typography, { shouldForwardProp: function (prop) { return prop !== 'insets'; } })(function (_a) {
    var type = _a.type, insets = _a.insets, theme = _a.theme;
    return (__assign(__assign(__assign({ color: theme.palette.text.primary }, (type === SectionType.HEADER && {
        backgroundColor: isLightTheme(theme) ? neutral60opacity05 : gray40opacity10,
        padding: "".concat(theme.spacing(1), " ").concat(theme.spacing(1.5)),
    })), (type === SectionType.HEADER &&
        insets && {
        marginBottom: theme.spacing(2),
    })), (type === SectionType.TITLE &&
        insets && {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2.5),
    })));
});
var HeaderContent = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'inherit',
        flexDirection: 'inherit',
        padding: "0 ".concat(theme.spacing(1.5)),
    });
});
var SectionField = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.insets, insets = _b === void 0 ? false : _b, sx = _a.sx, _c = _a.type, type = _c === void 0 ? SectionType.TITLE : _c, value = _a.value, _d = _a.variant, sectionVariant = _d === void 0 ? 'normal' : _d, props = __rest(_a, ["children", "className", "insets", "sx", "type", "value", "variant"]);
    return (React.createElement(Root, __assign({}, { className: className, sx: sx }, { variant: sectionVariant }),
        React.createElement(Label, __assign({}, { type: type, insets: insets }, { variant: "h5" }, props), value),
        type === SectionType.TITLE ? children : React.createElement(HeaderContent, null, children)));
};
export default SectionField;
